import { createI18n } from "vue-i18n";

async function loadLocaleMessages(locale: string) {
    let messages;
    switch (locale) {
        case "no":
            messages = await import("./no.json");
            break;
        case "en":
            messages = await import("./en.json");
            break;
        default:
            throw new Error(`Unsupported locale: ${locale}`);
    }
    i18n.global.setLocaleMessage(locale, messages.default);
    i18n.global.locale.value = locale;

    return messages.default;
}

const i18n = createI18n({
    legacy: false,
    locale: "no",
    fallbackLocale: "en",
    messages: {},
});

export { i18n, loadLocaleMessages };
